import { apiInstance } from 'configuration/axios'
import MockAdapter from 'axios-mock-adapter'

const useMockApi = (): MockAdapter => {
  // Register Custom Sweet Alert Button
  return new MockAdapter(apiInstance, { onNoMatch: 'throwException' })
}

export default useMockApi
